import React from 'react'
import { RecoilRoot } from 'recoil'
import { CookiesProvider } from 'react-cookie';

const wrapWithProvider = ({ element}) => {
    return <CookiesProvider>
        <RecoilRoot>{element}</RecoilRoot>
    </CookiesProvider>
}
export default wrapWithProvider